import React, { useState } from 'react'
import CarWhiteSvg from '../../../assets/icons/CarWhiteSvg'
import RedoBlueSvg from '../../../assets/icons/RedoBlueSvg'
import RedoRedSvg from '../../../assets/icons/RedoRedSvg'
import { Collapse } from 'reactstrap'
import DurumBadge from './DurumBadge'
import SmsDurumBadge from './SmsDurumBadge'

import './GuestHistoryItem.css'

const GuestHistoryItem = ({ item, sendSmsAgain, cancelInvitation }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div key={item.id}>
      <div className='rezervasyon-item'>
        <div style={{ display: 'flex', gap: '.5rem' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'radial-gradient(#C8EDF8, #92D7EC)',
              padding: '.8rem',
              borderRadius: '100%',
            }}
          >
            <CarWhiteSvg width={'.9rem'} />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              justifyContent: 'center',
              margin: '0 0 0 .4rem',
              lineHeight: '1.3',
            }}
          >
            <div style={{ fontWeight: '500' }}>{item.misafir_turu}</div>
            <div>{item.guest_name}</div>
          </div>
        </div>
        <div
          onClick={() => setIsOpen(!isOpen)}
          className='detay-button'
          style={{
            backgroundColor: '#1E9DC4',
          }}
        >
          {isOpen ? 'Gizle' : 'Detay'}
        </div>
      </div>
      <Collapse isOpen={isOpen} style={{ margin: '1rem 0 1rem 0' }}>
        <div style={{ border: '1px solid #F3F3F3' }}>
          <div className='clp-list-item1'>
            <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>Durum: </div>
            <div style={{ margin: '0 0 0 .3rem' }}>{<DurumBadge text={item.durum} />}</div>
          </div>
          <div className='clp-list-item2'>
            <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>Giriş Tipi: </div>
            <div style={{ margin: '0 0 0 .3rem' }}>{item.misafir_turu}</div>
          </div>
          {/* <div className='clp-list-item1'>
            <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>Misafir Sayısı: </div>
            <div style={{ margin: '0 0 0 .3rem' }}>{item.guest_count}</div>
          </div> */}
          <div className='clp-list-item2'>
            {/* {item.number_plate ? (
              <React.Fragment>
                <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>Plaka: </div>
                <div style={{ margin: '0 .8rem 0 .3rem' }}>{item.number_plate}</div>
              </React.Fragment>
            ) : null} */}
            <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>Telefon: </div>
            <div style={{ margin: '0 0 0 .3rem' }}>{item.tel}</div>
          </div>
          {item.sms_durum ? (
            <React.Fragment>
              <div className='clp-list-item1'>
                <div style={{ margin: '0 0 0 .7rem', fontWeight: 'bold' }}>Giriş SMS Durumu: </div>
                <div style={{ margin: '0 0 0 .3rem' }}>{<SmsDurumBadge text={item.sms_durum} />}</div>
              </div>
            </React.Fragment>
          ) : null}
        </div>
        <div
          className='rezervasyon-item-buttons'
          style={{
            justifyContent: 'center',
          }}
        >
          {item.durum === 'Aktif' && item.sms_durum !== 'İletildi' ? (
            <div
              className='rezervasyon-item-button'
              onClick={sendSmsAgain}
              style={{
                border: '1px solid #1e9dc4',
                color: '#1E9DC4',
              }}
            >
              <RedoBlueSvg width={'.8rem'} />
              <div>Giriş Bağlantısını Yeniden Gönder</div>
            </div>
          ) : null}
          {item.durum !== 'İptal Edildi' && item.durum !== 'İptal edildi' ? (
            <div
              className='rezervasyon-item-button'
              style={{
                border: '1px solid #b72424',
                color: '#B72424',
              }}
              onClick={cancelInvitation}
            >
              <RedoRedSvg width={'.8rem'} />
              <div>İptal Et</div>
            </div>
          ) : null}
        </div>
      </Collapse>
    </div>
  )
}

export default GuestHistoryItem
